import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgModelOptionsDirective } from './ng-model-options.directive';

@NgModule({
  declarations: [NgModelOptionsDirective],
  imports: [CommonModule],
  exports: [NgModelOptionsDirective]
})
export class NgModelOptionsModule {}
